
import {
  CharacterSpell,
  Spellbook,
  SpellbookModifier,
  UpgradableNumber,
} from "@dndModels";

/**
 * This represents a Book that a spellcaster is 
 * able to keep their spells in.  
 * It's primarily for Wizards, 
 * but Pact of the Tome Warlocks who take the 
 * Book of Ancient Secrets Eldritch Invocation
 * also gain access to it.
 * The Warlock one can only hold Rituals, and they
 * don't prepare from it, but they're allowed to
 * learn from ANY spell list, where Wizards can 
 * only learn from the Wizard Spell List
 * (which is the largest one by far).
 */
export class CharacterSpellbook {
  spells: CharacterSpell[] = [];
  spellbook: Spellbook | null = null;
  modifiers: CharacterSpellbookModifier[] = [];
  free_spells = 0;
  used_free_spells = 0;
  extra_free_spells = 0;
  // spell_ids: string[] = [];
  modifying_spell_true_id = "";
  time_num_per_spell_level = 2;
  cost_per_spell_level = 50;

  constructor(obj?: any) {
    if (obj) {
      this.spells = [];
      // this.spell_ids = [];
      if (obj.spells) {
        obj.spells.forEach((spell: any) => {
          const char_spell = new CharacterSpell(spell);
          this.spells.push(char_spell);
          // this.spell_ids.push(char_spell.spell_id);
        });
      }
      this.extra_free_spells = obj.extra_free_spells ? obj.extra_free_spells : 0;
      this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : null;
      this.modifying_spell_true_id = obj.modifying_spell_true_id ? obj.modifying_spell_true_id : "";
    }
  }

  // get unused_free_spells() {
  //   return this.free_spells + this.extra_free_spells - this.used_free_spells;
  // }

  get knowledge_usage_key(): string {
    if (this.spellbook) {
      return this.spellbook.knowledge_usage_key;
    }
    return "";
  }

  get learning_message() {
    return this.spellbook?.learning_message??"";
  }

  get time_unit() {
    return this.spellbook?.time_unit??4;
  }

  get cost_unit() {
    return this.spellbook?.cost_unit??4;
  }

  get total_unused_free_spells() {
    return this.free_spells + this.extra_free_spells + this.modifiers.map(o => o.unused_free_spells).reduce((a, b) => a + b, 0) - this.used_free_spells;
  }

  toDBObj(): any {
    return {
      spells: this.spells.map(o => o.toDBObj()),
      extra_free_spells: this.extra_free_spells,
      modifying_spell_true_id: this.modifying_spell_true_id
    };
  }

  clone(): CharacterSpellbook {
    return new CharacterSpellbook(this);
  }

  copy(copyMe: CharacterSpellbook): void {
    this.spells = [...copyMe.spells];
    // this.spell_ids = [...copyMe.spell_ids];
    this.spellbook = copyMe.spellbook;
    this.free_spells = copyMe.free_spells;
    this.extra_free_spells = copyMe.extra_free_spells;
    this.modifying_spell_true_id = copyMe.modifying_spell_true_id;
    this.cost_per_spell_level = copyMe.cost_per_spell_level;
    this.time_num_per_spell_level = copyMe.time_num_per_spell_level;
  }
}

export class CharacterSpellbookModifier {
  modifier: SpellbookModifier | null = null;
  unused_free_spells = 0;
  source_true_id = "";
  time_num_per_spell_level = 2;
  cost_per_spell_level = 50;

  // constructor(obj?: any) {
  //   if (obj) {
  //     this.unused_free_spells = obj.unused_free_spells ? obj.unused_free_spells : 0;
  //     this.source_true_id = obj.source_true_id ? obj.source_true_id : "";
  //   }
  // }

  get _id() {
    return this.modifier?._id??"";
  }

  get name() {
    return this.modifier?.name??"";
  }

  get learning_message() {
    return this.modifier?.learning_message??"";
  }

  get schools() {
    return this.modifier?.schools??[];
  }

  get extra_free_spells() {
    return this.modifier?.extra_free_spells??new UpgradableNumber();
  }

  get time_unit() {
    return this.modifier?.time_unit??4;
  }

  get cost_unit() {
    return this.modifier?.cost_unit??4;
  }

  clone(): CharacterSpellbookModifier {
    const new_obj = new CharacterSpellbookModifier();
    new_obj.copy(this);
    return new_obj;
  }

  copy(copyMe: CharacterSpellbookModifier): void {
    this.modifier = copyMe.modifier;
    this.unused_free_spells = copyMe.unused_free_spells;
    this.time_num_per_spell_level = copyMe.time_num_per_spell_level;
    this.cost_per_spell_level = copyMe.cost_per_spell_level;
  }
}